import './Filters.css'

import { InfiniteData } from '@tanstack/react-query'
import React, { memo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { JobTitlesResponse } from '../../api/types'
import { SelectWithSearchOpt } from '../Selects'

interface IFilterDropdownProps {
  label: string
  defaultOption: string
  filterBy: string
  hasNextPage?: boolean
  fetchNextPage?: () => void
  data?: InfiniteData<JobTitlesResponse>
  isFetchingNextPage?: boolean
  isFetching?: boolean
  setInputValue: (value: string) => void
  queryKey?: string
}

const FilterWithSearching: React.FC<IFilterDropdownProps> = memo(
  ({
    label,
    defaultOption,
    filterBy,
    hasNextPage,
    fetchNextPage,
    data,
    isFetchingNextPage,
    setInputValue: setInputValueProp,
    isFetching,
  }) => {
    const [searchParams, setSearchParams] = useSearchParams()

    const handleClick = (option: string) => {
      if (option === defaultOption) {
        searchParams.delete(filterBy)
        searchParams.delete('p')
        setSearchParams(searchParams)
      } else {
        searchParams.set(filterBy, option)
        searchParams.delete('p')
        setSearchParams(searchParams)
      }
    }

    const handleInputChange = (value: string) => {
      setInputValueProp(value)
    }

    const clearFilter = (
      e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => {
      e.stopPropagation()
      searchParams.delete(filterBy)
      searchParams.delete('p')
      setSearchParams(searchParams)
    }

    const filterItems = data ?
        data.pages.map((page: JobTitlesResponse) => page.items).flat() :
        []

    return (
      <>
        <SelectWithSearchOpt
          options={[defaultOption, ...filterItems]}
          selectedOption={searchParams.get(filterBy) || defaultOption}
          setDefaultOption={clearFilter}
          onInputChange={handleInputChange}
          onSelect={handleClick}
          isFetching={isFetching}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
        />
        <div className="tc-mv-admin-filter-label">{label}</div>
      </>
    )
  },
)

export { FilterWithSearching }
